var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreferenciasIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.6667 175V125H108.333V141.667H175V158.333H108.333V175H91.6667ZM25 158.333V141.667H75V158.333H25ZM58.3333 125V108.333H25V91.6667H58.3333V75H75V125H58.3333ZM91.6667 108.333V91.6667H175V108.333H91.6667ZM125 75V25H141.667V41.6667H175V58.3333H141.667V75H125ZM25 58.3333V41.6667H108.333V58.3333H25Z",
    fill: "#E8EAED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferenciasIcon);
export default __webpack_public_path__ + "static/media/preferenciasIcon.6995a6541967782470e54ee4a60134b6.svg";
export { ForwardRef as ReactComponent };